import React, { useState, useEffect } from "react";
import Adminsidebar from "../components/Adminsidebar";
import Adminheader from "../components/Adminheader";
import Uppercase from "../components/Uppercase";
import "./Adminanalytics.css";
import axios from "axios";
import { useYearContext } from "../components/YearContext";

const Adminanalytics = () => {
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false);
  const openSidebar = () => {
    setOpenSidebarToggle(!openSidebarToggle);
  };

  const { yearSelected } = useYearContext();

  const [loading, setLoading] = useState(true);

  const [data, setData] = useState({
    team: [
      { title: "Total Assigned", value: "0" },
      { title: "Paid", value: "0" },
      { title: "Pending", value: "0" },
    ],
    clients: [
      { title: "New Clients", value: "0" },
      { title: "Existing Clients", value: "0" },
      { title: "Documents Pending", value: "0" },
      { title: "Voice Mail", value: "0" },
      { title: "Preparation Pending", value: "0" },
      { title: "Paid Clients", value: "0" },
      { title: "Payment Pending Clients", value: "0" },
      { title: "Pending Amount", value: "0" },
      { title: "Partial Payment Clients", value: "0" },
      { title: "Partial Amount", value: "0" },
      { title: "Completed", value: "0" },
    ],
    leads: [
      { title: "Total Leads", value: "0" },
      { title: "Registered", value: "0" },
      { title: "Callback", value: "0" },
      { title: "Interested", value: "0" },
      { title: "Not Interested", value: "0" },
      { title: "Duplicate", value: "0" },
      { title: "Voice mails", value: "0" },
      { title: "Citizens", value: "0" },
      { title: "Service Emails Sent", value: "0" },
    ],
    referrals: [
      { title: "Referrals Received", value: "0" },
      { title: "Successful Referrals", value: "0" },
      { title: "Referral Conversion Rate", value: "0" },
    ],
  });

  //team

  const [employeeData, setEmployeeData] = useState([]);

  const fetchEmployeeData = async () => {
    try {
      const response = await axios.get(
        "https://api.easytaxexperts.com/api/getemployees"
      );
      setEmployeeData(response.data);
    } catch (error) {
      console.error("Error fetching employee data:", error);
    }
  };

  useEffect(() => {
    fetchEmployeeData();
  }, []);

  const filterTeamDocuments = employeeData.filter((doc) => {
    const documentDate = doc.dateHired ? doc.dateHired.substring(0, 10) : "";

    const nextYear = (parseInt(yearSelected) + 1).toString();
    // const startDate = `${parseInt(nextYear) - 1}-09-01`;
    // const endDate = `${nextYear}-08-31`;
    const startDate = `${parseInt(nextYear) - 1}-11-30`;
const endDate = `${nextYear}-11-29`;

    return documentDate >= startDate && documentDate <= endDate;
  });

  const [invoices, setInvoices] = useState([]);

  useEffect(() => {
    fetchinvoices();
  }, []);

  const fetchinvoices = async () => {
    try {
      const response = await axios.get(" https://api.easytaxexperts.com/getinvoicess");

      if (response.data.success) {
        setInvoices(response.data.result);
        console.log(response.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const filterInvoiceDocuments = invoices.filter((each) => {
    const documentDate = each.InvoiceDate ? each.InvoiceDate : "";

    const nextYear = (parseInt(yearSelected) + 1).toString();
    // const startDate = `${parseInt(nextYear) - 1}-09-01`;
    // const endDate = `${nextYear}-08-31`;
const startDate = `${parseInt(nextYear) - 1}-11-30`;
const endDate = `${nextYear}-11-29`;

    const isYearMatch = documentDate >= startDate && documentDate <= endDate;

    return isYearMatch;
  });

  useEffect(() => {
    const total = filterTeamDocuments.reduce((acc, each) => {
      acc += Number(each.targetAssigned);
      return acc;
    }, 0);
    const invoicestatusesToCount = ["Paid"];
    const invoiceTotal = filterInvoiceDocuments.reduce((acc, each) => {
      const normalizedStatus = each.PaymentStatus;
      if (invoicestatusesToCount.includes(normalizedStatus)) {
        acc[normalizedStatus] =
          (acc[normalizedStatus] || 0) + Number(each.totalBill);
      }
      return acc;
    }, {});

    setData((prevData) => {
      return {
        ...prevData,
        team: prevData.team.map((card) => {
          if (card.title === "Total Assigned") {
            return { ...card, value: total };
          }

          if (card.title === "Paid") {
            return { ...card, value: `${invoiceTotal.Paid || 0}` };
          }
          if (card.title === "Pending") {
            return {
              ...card,
              value: total - `${invoiceTotal.Paid || 0}`,
            };
          }

          return card;
        }),
      };
    });
  }, [filterTeamDocuments, filterInvoiceDocuments]);

  //leads

  const [leadsData, setleadsData] = useState([]);
  const fetchLeadsDocuments = async () => {
    try {
      const response = await axios.get(" https://api.easytaxexperts.com/leads");
      setleadsData(response.data);
    } catch (error) {
      console.error("Error fetching documents:", error);
    }
  };
  useEffect(() => {
    fetchLeadsDocuments();
  }, []);

  const filterLeadDocuments = leadsData.filter((doc) => {
    const documentDate = doc.created_at ? doc.created_at.substring(0, 10) : "";
    const nextYear = (parseInt(yearSelected) + 1).toString();
    // const startDate = `${parseInt(nextYear) - 1}-09-01`;
    // const endDate = `${nextYear}-08-31`;
const startDate = `${parseInt(nextYear) - 1}-11-30`;
const endDate = `${nextYear}-11-29`;

    return documentDate >= startDate && documentDate <= endDate;
  });

  const statusesToCount = [
    "Voicemail",
    "Callback",
    "Intrested",
    "NotIntrested",
    "Duplicate",
    "Registered",
  ];

  useEffect(() => {
    const totalRecords = filterLeadDocuments.length;
    const countLeadsByStatus = filterLeadDocuments.reduce((acc, doc) => {
      const normalizedStatus = doc.status.replace(/\s+/g, "");
      if (statusesToCount.includes(normalizedStatus)) {
        acc[normalizedStatus] = (acc[normalizedStatus] || 0) + 1;
      }
      return acc;
    }, {});

    setData((prevData) => {
      return {
        ...prevData,
        leads: prevData.leads.map((card) => {
          if (card.title === "Total Leads") {
            return { ...card, value: totalRecords };
          }
          if (card.title === "Callback") {
            return { ...card, value: `${countLeadsByStatus.Callback || 0}` };
          }
          if (card.title === "Registered") {
            return { ...card, value: `${countLeadsByStatus.Registered || 0}` };
          }
          if (card.title === "Interested") {
            return { ...card, value: `${countLeadsByStatus.Intrested || 0}` };
          }
          if (card.title === "Not Interested") {
            return {
              ...card,
              value: `${countLeadsByStatus.NotIntrested || 0}`,
            };
          }
          if (card.title === "Duplicate") {
            return { ...card, value: `${countLeadsByStatus.Duplicate || 0}` };
          }
          if (card.title === "Voice mails") {
            return { ...card, value: `${countLeadsByStatus.Voicemail || 0}` };
          }
          return card;
        }),
      };
    });
  }, [filterLeadDocuments]);

  //clients

  const [clientsData, setclientsData] = useState([]);
  const fetchClientData = async () => {
    try {
      const response = await axios.get(" https://api.easytaxexperts.com/get/clientdatadetails");
      if (response.data.success) {
        setclientsData(response.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchClientData();
  }, []);

  const filterClientDocuments = clientsData.filter((doc) => {
    const documentDate = doc.registered_at
      ? doc.registered_at.substring(0, 10)
      : "";

    const nextYear = (parseInt(yearSelected) + 1).toString();

    // const startDate = `${parseInt(nextYear) - 1}-09-01`;
    // const endDate = `${nextYear}-08-31`;

    const startDate = `${parseInt(nextYear) - 1}-11-30`;
const endDate = `${nextYear}-11-29`;


    return documentDate >= startDate && documentDate <= endDate;
  });

  const clientstatusesToCount = [
    "Documentpending",
    "Voicemail",
    "Preparationpending",
    "Paid",
    "Paymentpending",
    "Partialpayment",
    "Complete",
  ];

  useEffect(() => {
    const totalRecords = filterClientDocuments.length;
    const countClientsByStatus = filterClientDocuments.reduce((acc, doc) => {
      const normalizedStatus = doc.status.replace(/\s+/g, "");
      if (clientstatusesToCount.includes(normalizedStatus)) {
        acc[normalizedStatus] = (acc[normalizedStatus] || 0) + 1;
      }
      return acc;
    }, {});

    setData((prevData) => {
      return {
        ...prevData,
        clients: prevData.clients.map((card) => {
          if (card.title === "New Clients") {
            return { ...card, value: totalRecords };
          }
          if (card.title === "Documents Pending") {
            return {
              ...card,
              value: `${countClientsByStatus.Documentpending || 0}`,
            };
          }
          if (card.title === "Voice Mail") {
            return { ...card, value: `${countClientsByStatus.Voicemail || 0}` };
          }
          if (card.title === "Preparation Pending") {
            return {
              ...card,
              value: `${countClientsByStatus.Preparationpending || 0}`,
            };
          }
          if (card.title === "Paid Clients") {
            return {
              ...card,
              value: `${countClientsByStatus.Paid || 0}`,
            };
          }
          if (card.title === "Payment Pending Clients") {
            return {
              ...card,
              value: `${countClientsByStatus.Paymentpending || 0}`,
            };
          }
          if (card.title === "Partial Payment Clients") {
            return {
              ...card,
              value: `${countClientsByStatus.Partialpayment || 0}`,
            };
          }
          if (card.title === "Completed") {
            return { ...card, value: `${countClientsByStatus.Complete || 0}` };
          }
          return card;
        }),
      };
    });
  }, [filterClientDocuments]);

  useEffect(() => {
    setTimeout(() => setLoading(false), 1000);
  }, []);

  const [toggle, setToggle] = useState(1);

  function updateToggle(id) {
    setToggle(id);
  }

  //fetch contact us
  const [contactDetails, setContactDetails] = useState([]);
  const fetchContactus = async () => {
    try {
      const response = await axios.get(" https://api.easytaxexperts.com/get/contactus");
      if (response.data.success) {
        setContactDetails(response.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchContactus();
  }, []);

  const filterDocuments = contactDetails.filter((each) => {
    const documentDate = each.Sent_Time ? each.Sent_Time.substring(0, 10) : "";

    const nextYear = (parseInt(yearSelected) + 1).toString();
    // const startDate = `${parseInt(nextYear) - 1}-09-01`;
    // const endDate = `${nextYear}-08-31`;
const startDate = `${parseInt(nextYear) - 1}-11-30`;
const endDate = `${nextYear}-11-29`;

    const isYearMatch = documentDate >= startDate && documentDate <= endDate;

    return isYearMatch;
  });

  const reversedDocuments = filterDocuments.slice().reverse();

  //fetch refferals

  const [referralData, setReferralData] = useState([]);
  const fetchReferrals = async () => {
    try {
      const response = await axios.get(" https://api.easytaxexperts.com/get/referrals");
      if (response.data.success) {
        setReferralData(response.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchReferrals();
  }, []);

  const filterreferralDocuments = referralData.filter((each) => {
    const documentDate = each.DateandTime
      ? each.DateandTime.substring(0, 10)
      : "";

    const nextYear = (parseInt(yearSelected) + 1).toString();
    // const startDate = `${parseInt(nextYear) - 1}-09-01`;
    // const endDate = `${nextYear}-08-31`;
const startDate = `${parseInt(nextYear) - 1}-11-30`;
const endDate = `${nextYear}-11-29`;

    const isYearMatch = documentDate >= startDate && documentDate <= endDate;

    return isYearMatch;
  });


  useEffect(() => {
    const totalRecords = filterreferralDocuments.length;
    const referralEmails = filterreferralDocuments.map(
      (doc) => doc.ReferralEmail
    );
    const clientEmails = filterClientDocuments.map((doc) => doc.email);

    const successfulReferralsCount = referralEmails.filter((email) =>
      clientEmails.includes(email)
    ).length;

    setData((prevData) => {
      return {
        ...prevData,
        referrals: prevData.referrals.map((card) => {
          if (card.title === "Referrals Received") {
            return { ...card, value: totalRecords };
          }
          if (card.title === "Successful Referrals") {
            return { ...card, value: successfulReferralsCount };
          }
          if (card.title === "Referral Conversion Rate") {
            return {
              ...card,
              value:
                successfulReferralsCount == 0
                  ? "0%"
                  : `${(successfulReferralsCount / totalRecords) * 100}%`,
            };
          }

          return card;
        }),
      };
    });
  }, [filterreferralDocuments]);

  const reversedreferralDocuments = filterreferralDocuments.slice().reverse();

  //fetch chatbot

  const [chatbotData, setChatbotData] = useState([]);
  const fetchChatbot = async () => {
    try {
      const response = await axios.get(" https://api.easytaxexperts.com/get/chatbot");
      if (response.data.success) {
        setChatbotData(response.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchChatbot();
  }, []);

  const filterchatbotDocuments = chatbotData.filter((each) => {
    const documentDate = each.Submitted_At
      ? each.Submitted_At.substring(0, 10)
      : "";

    const nextYear = (parseInt(yearSelected) + 1).toString();
    // const startDate = `${parseInt(nextYear) - 1}-09-01`;
    // const endDate = `${nextYear}-08-31`;
const startDate = `${parseInt(nextYear) - 1}-11-30`;
const endDate = `${nextYear}-11-29`;

    const isYearMatch = documentDate >= startDate && documentDate <= endDate;

    return isYearMatch;
  });

  const reversedchatbotDocuments = filterchatbotDocuments.slice().reverse();

  //fetch careers

  const [careersData, setCareersData] = useState([]);
  const fetchCareers = async () => {
    try {
      const response = await axios.get(" https://api.easytaxexperts.com/get/careers");
      if (response.data.success) {
        setCareersData(response.data.result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchCareers();
  }, []);

  const filtercareersDocuments = careersData.filter((each) => {
    const documentDate = each.DateandTime
      ? each.DateandTime.substring(0, 10)
      : "";

    const nextYear = (parseInt(yearSelected) + 1).toString();
    // const startDate = `${parseInt(nextYear) - 1}-09-01`;
    // const endDate = `${nextYear}-08-31`;
const startDate = `${parseInt(nextYear) - 1}-11-30`;
const endDate = `${nextYear}-11-29`;

    const isYearMatch = documentDate >= startDate && documentDate <= endDate;

    return isYearMatch;
  });

  const reversedcareersDocuments = filtercareersDocuments.slice().reverse();

  const handleDownloaddoc = (filePath) => {
    // Replace backslashes with forward slashes in the filePath
    const formattedFilePath = filePath.replace(/\\/g, "/");
    // Construct the download URL based on the formatted filePath
    const downloadUrl = ` https://api.easytaxexperts.com/${formattedFilePath}`;
    // Create a temporary link
    const link = document.createElement("a");
    link.href = downloadUrl;
    link.target = "_blank";
    link.download = formattedFilePath.split("/").pop(); // Set the file name
    // Append the link to the body
    document.body.appendChild(link);
    // Programmatically click on the link to trigger the download
    link.click();
    // Remove the link from the body
    document.body.removeChild(link);
  };

  return (
    <div>
      <Uppercase />
      <div className="invoice-grid-container">
        <Adminheader openSidebar={openSidebar} />
        <Adminsidebar
          openSidebarToggle={openSidebarToggle}
          openSidebar={openSidebar}
        />
        <main className="main-container mt-2">
          <div className="container">
            <div className=" py-4">
              <ul className=" d-flex product_links justify-content-center justify-content-lg-start">
                {/* <li
                  className={`col-lg-1 col-md-2 col-sm-4  ${
                    toggle === 1 ? "productactive" : ""
                  }`}
                  onClick={() => updateToggle(1)}
                >
                  Team
                </li> */}
                <li
                  className={`col-lg-1 col-md-2 col-sm-4 ${
                    toggle === 1 ? "productactive" : ""
                  }`}
                  onClick={() => updateToggle(1)}
                >
                  Clients
                </li>
                {/* <li
                  className={`col-lg-1 col-md-2 col-sm-4  ${
                    toggle === 3 ? "productactive" : ""
                  }`}
                  onClick={() => updateToggle(3)}
                >
                  Leads
                </li> */}
                <li
                  className={`col-lg-1 col-md-2 col-sm-4  ${
                    toggle === 2 ? "productactive" : ""
                  }`}
                  onClick={() => updateToggle(2)}
                >
                  Referrals
                </li>
               
                <li
                  className={`col-lg-1 col-md-2 col-sm-4  ${
                    toggle === 3 ? "productactive" : ""
                  }`}
                  onClick={() => updateToggle(3)}
                >
                  Contact
                </li>
               
              </ul>
            </div>

            {/* <div
              className={
                toggle === 1 ? "product_showcontent" : "product_content"
              }
            >
              <div className="row text-center gap-2">
                {data.team.map((card, index) => (
                  <div className="col-lg-3 col-sm-12 col-md-4" key={index}>
                    <div
                      className="card py-2"
                      style={{ backgroundColor: "#d3d3d3" }}
                    >
                      <div className="card-text">
                        <h6>{card.title}</h6>
                        <h4>{card.value}</h4>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-5 table-responsive">
                <table className="table table-hover table-bordered">
                  <thead className="table-primary">
                    <tr>
                      <th></th>
                      <th colspan="3" className="text-center">
                        Total Target
                      </th>
                      <th colspan="3" className="text-center">
                        Today Target
                      </th>
                    </tr>
                    <tr>
                      <th>Caller</th>
                      <th>Assigned</th>
                      <th>Achieved</th>
                      <th>Pending</th>
                      <th>Assigned</th>
                      <th>Achieved</th>
                      <th>Pending</th>
                    </tr>
                  </thead>

                  <tbody></tbody>
                </table>
              </div>
            </div> */}

            <div
              className={
                toggle === 1 ? "product_showcontent" : "product_content"
              }
            >
              <div className="row text-center gap-2">
                {data.clients.map((card, index) => (
                  <div className="col-lg-3 col-sm-12 col-md-4" key={index}>
                    <div
                      className="card py-2"
                      style={{ backgroundColor: "#d3d3d3" }}
                    >
                      <div className="card-text">
                        <h6>{card.title}</h6>
                        <h4>{card.value}</h4>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* <div
              className={
                toggle === 3 ? "product_showcontent" : "product_content"
              }
            >
              <div className="row text-center gap-2">
                {data.leads.map((card, index) => (
                  <div className="col-lg-3 col-sm-12 col-md-4" key={index}>
                    <div
                      className="card py-2"
                      style={{ backgroundColor: "#d3d3d3" }}
                    >
                      <div className="card-text">
                        <h6>{card.title}</h6>
                        <h4>{card.value}</h4>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div> */}

            <div
              className={
                toggle === 2 ? "product_showcontent" : "product_content"
              }
            >
              <div className="row text-center gap-2">
                {data.referrals.map((card, index) => (
                  <div className="col-lg-3 col-sm-12 col-md-4" key={index}>
                    <div
                      className="card py-2"
                      style={{ backgroundColor: "#d3d3d3" }}
                    >
                      <div className="card-text">
                        <h6>{card.title}</h6>
                        <h4>{card.value}</h4>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
              <div className="mt-5 table-responsive">
                <table className="table table-hover  table-bordered">
                  <thead className="table-primary">
                    <tr>
                      <th>S.NO</th>
                      <th>Referral Name</th>
                      <th>Referral Email</th>
                      <th>Referral Phone</th>
                      <th>Referred By</th>
                      <th>Referral Date</th>
                      {/* <th>Caller Name</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {reversedreferralDocuments.map((each, index) => (
                      <tr key={each.id}>
                        <td>{index + 1} </td>
                        <td>{each.ReferralName}</td>
                        <td>{each.ReferralEmail}</td>
                        <td>{each.ReferralPhoneNumber}</td>
                        <td>{each.Clientemail}</td>
                        <td>{each.DateandTime}</td>
                        {/* <td>{each.callername}</td> */}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

           
            <div
              className={
                toggle === 3 ? "product_showcontent" : "product_content"
              }
            >
              <div className="mt-3 table-responsive">
                <table className="table table-hover  table-bordered">
                  <thead className="table-primary">
                    <tr>
                      <th>S.No</th>
                      <th>Name</th>
                      <th>Phone No</th>
                      <th>Email ID</th>
                      <th>Subject</th>
                      <th>Message Us</th>
                      <th>Sent Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {reversedDocuments.map((each, index) => (
                      <tr key={each.id}>
                        <td>{index + 1}</td>
                        <td>{each.Name}</td>
                        <td>{each.Phone_Number}</td>
                        <td>{each.Email_ID}</td>
                        <td>{each.Subject}</td>
                        <td>{each.Message_Us}</td>
                        <td>{each.Sent_Time}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>

            
          </div>
        </main>
      </div>
    </div>
  );
};

export default Adminanalytics;
